import React from "react";

interface WordDefinitionModalProps {
  word: string;
  definition: string;
  imageUrl?: string;
  position: { x: number; y: number };
  width?: number;
}

const capitalizeFirstLetter = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const WordDefinitionModal: React.FC<WordDefinitionModalProps> = ({
  word,
  definition,
  imageUrl,
  position,
  width = 300,
}) => {
  return (
    <div
      className="word-definition-modal"
      style={{
        position: "absolute",
        left: position.x,
        top: position.y,
        zIndex: 1000,
        backgroundColor: "white",
        padding: "1rem",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        maxWidth: width,
        width: width,
        border: "2px solid #eab60b",
        wordBreak: "break-word",
      }}
    >
      <h3 style={{ margin: "0 0 0.5rem 0", color: "#444444" }}>
        {capitalizeFirstLetter(word)}
      </h3>
      <p style={{ margin: "0 0 0.5rem 0", color: "#666666" }}>{definition}</p>
      {imageUrl && (
        <img
          src={imageUrl}
          alt={`Illustration of ${word}`}
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "4px",
            marginTop: "0.5rem",
          }}
        />
      )}
    </div>
  );
};

export default WordDefinitionModal;
